import { render, staticRenderFns } from "./ItemEditPage.vue?vue&type=template&id=0603d95a&"
import script from "./ItemEditPage.vue?vue&type=script&lang=js&"
export * from "./ItemEditPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports